export function isValidCpf(cpf: string): boolean {
    const cleaned = cpf.replace(/\D/g, '');

    if (cleaned.length !== 11) return false;
    if (/^(\d)\1{10}$/.test(cleaned)) return false;

    const calcDigit = (base: string, factor: number): number => {
        let total = 0;
        for (const digit of base) total += Number(digit) * factor--;
        const remainder = (total * 10) % 11;
        return remainder === 10 ? 0 : remainder;
    };

    const digit1 = calcDigit(cleaned.slice(0, 9), 10);
    const digit2 = calcDigit(cleaned.slice(0, 9) + digit1, 11);

    return digit1 === Number(cleaned[9]) && digit2 === Number(cleaned[10]);
}